import { useState } from 'react';

function CLanguageModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to C Programming",
      content: [
        "What is C Programming?",
        "History of C Language",
        "Features of C",
        "Setting up the C programming environment",
        "Compiling and running C programs",
        "Structure of a C program",
        "Basic syntax and comments in C"
      ]
    },
    {
      title: "Module 2: Data Types and Variables",
      content: [
        "Primitive Data Types in C: int, char, float, double",
        "Modifiers in C: short, long, signed, unsigned",
        "Declaring and initializing variables",
        "Constants and literals in C",
        "Typecasting and type conversion",
        "Input and output in C (scanf, printf)"
      ]
    },
    {
      title: "Module 3: Control Flow",
      content: [
        "If-else statements in C",
        "Switch case statements",
        "For loop, while loop, and do-while loop",
        "Nested loops",
        "Break and continue statements",
        "Logical operators and relational operators"
      ]
    },
    {
      title: "Module 4: Functions in C",
      content: [
        "What are functions in C?",
        "Declaring and defining functions",
        "Function parameters and return values",
        "Types of functions: standard library functions, user-defined functions",
        "Recursion in C",
        "Scope of variables (local vs global variables)",
        "Passing arguments by value and by reference"
      ]
    },
    {
      title: "Module 5: Arrays in C",
      content: [
        "What are arrays in C?",
        "Declaring and initializing arrays",
        "One-dimensional and multi-dimensional arrays",
        "Accessing array elements",
        "Array manipulation techniques (sorting, searching)",
        "Passing arrays to functions",
        "Dynamic memory allocation using pointers and arrays"
      ]
    },
    {
      title: "Module 6: Pointers in C",
      content: [
        "Introduction to pointers in C",
        "Declaring and initializing pointers",
        "Pointer arithmetic",
        "Pointer to pointer",
        "Pointers with arrays and functions",
        "Memory management with malloc, calloc, free",
        "Function pointers"
      ]
    },
    {
      title: "Module 7: Strings in C",
      content: [
        "What are strings in C?",
        "String handling functions (strlen, strcpy, strcat, strcmp)",
        "Arrays of strings and 2D arrays",
        "String input and output",
        "String manipulation with pointers",
        "Dynamic memory allocation for strings"
      ]
    },
    {
      title: "Module 8: Structures and Unions",
      content: [
        "Introduction to structures in C",
        "Declaring and accessing structure members",
        "Nested structures",
        "Unions in C",
        "Differences between structures and unions",
        "Passing structures to functions"
      ]
    },
    {
      title: "Module 9: File Handling in C",
      content: [
        "Working with files in C",
        "Opening and closing files: fopen, fclose",
        "Reading from files: fscanf, fgets",
        "Writing to files: fprintf, fputs",
        "File pointer and file operations",
        "Error handling in file operations",
        "Binary file operations"
      ]
    },
    {
      title: "Module 10: Advanced C Topics",
      content: [
        "Memory management and garbage collection in C",
        "Bitwise operators and operations",
        "Linked lists in C",
        "Dynamic memory allocation using malloc, calloc, realloc, free",
        "Stacks and queues using linked lists",
        "C Preprocessor Directives: #define, #include, #ifdef",
        "Complex data structures (trees, graphs)"
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">C Language Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px' }}>{item}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CLanguageModule;
